import type { ClientInfo } from "../api/types/clientTypes.ts";

export const getOrganizationClientCode = (clientCode: string, clients: ClientInfo[]): string | undefined => {
  const client = clients.find((c) => c.clientCode === clientCode);
  if (!client) {
    return undefined;
  }

  if (client.type === "FundAdmin") {
    return client.clientCode;
  }

  const currentClientOrganizationCode =
    client.managedByClients.find((code) => !isEntriliaClientCode(code)) ?? client.managedByClients[0];

  return currentClientOrganizationCode;
};

// Entrilia staff see every client, so the first fund admin in their list is an arbitrary customer's organization.
export const getLogoLinkClientCode = (
  isEntriliaUser: boolean,
  clients: ClientInfo[],
  currentClientCode: string
): string => {
  if (isEntriliaUser) {
    const entriliaOrganization = clients.find((c) => isEntriliaClientCode(c.clientCode));
    if (entriliaOrganization) {
      return entriliaOrganization.clientCode;
    }
  }

  return clients.find((c) => c.type === "FundAdmin")?.clientCode || clients[0]?.clientCode || currentClientCode;
};

const entriliaClientCodes = ["entrilia", "entrilia51"];
const entriliaManagedOrganizations = ["entriliapartners", "optimafs", "seahavencapital"];

export const isEntriliaClientCode = (clientCode: string) => entriliaClientCodes.includes(clientCode);
export const isEntriliaManagedOrganization = (clientCode: string) => entriliaManagedOrganizations.includes(clientCode);
